// Copyright (c) 2018 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import ExcelLayoutModalBody from './excel-layout-modal-body';
import ExcelLayoutModalStruct from '../../../state/excel-layout-modal';
import ModalHeader from '../../modal/modal-header';
import WarrantyMediumModal from '../../modal/medium-modal';

const ExcelLayoutModal = props => {

    const id = props.excelLayoutModal.isNewLayout ?
        'CREATE_LAYOUT' :
        'EDIT_LAYOUT';

    return (
        <WarrantyMediumModal
            className='excel-layout-modal'
            isOpen={props.excelLayoutModal.isModalOpen}
        >
            <ModalHeader
                id={id}
                onModalClose={props.onModalClose}
            />
            <ExcelLayoutModalBody
                excelLayoutModal={props.excelLayoutModal}
                mappingId='key'
                mappingTable={props.mappingTable}
                onCancel={props.onModalClose}
                onColumnMove={props.onColumnMove}
                onColumnPush={props.onColumnPush}
                onColumnRemove={props.onColumnRemove}
                onLayoutDelete={props.onLayoutDelete}
                onLayoutNameBlur={props.onLayoutNameBlur}
                onLayoutNameChange={props.onLayoutNameChange}
                onSaveLayout={props.onSaveLayout}
                onSetAsDefaultChange={props.onSetAsDefaultChange}
                onSortByChange={props.onSortByChange}
                onSortDirectionChange={props.onSortDirectionChange}
                sortByList={props.sortByList}
            />
        </WarrantyMediumModal>
    );

};

ExcelLayoutModal.displayName = 'ExcelLayoutModal';
ExcelLayoutModal.propTypes = {
    excelLayoutModal: PropTypes.instanceOf(ExcelLayoutModalStruct).isRequired,
    mappingTable: PropTypes.arrayOf(PropTypes.object),
    onColumnMove: PropTypes.func.isRequired,
    onColumnPush: PropTypes.func.isRequired,
    onColumnRemove: PropTypes.func.isRequired,
    onLayoutDelete: PropTypes.func.isRequired,
    onLayoutNameBlur: PropTypes.func.isRequired,
    onLayoutNameChange: PropTypes.func.isRequired,
    onModalClose: PropTypes.func.isRequired,
    onSaveLayout: PropTypes.func.isRequired,
    onSetAsDefaultChange: PropTypes.func.isRequired,
    onSortByChange: PropTypes.func.isRequired,
    onSortDirectionChange: PropTypes.func.isRequired,
    sortByList: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ExcelLayoutModal;



// WEBPACK FOOTER //
// ./src/shared/components/excel-layout/excel-layout-modal/index.js